import { Brand, BrandSchema } from '../../../server/src/user/user.contract'

export function resolveBrand(value?: string | null): Brand {
  const parsed = BrandSchema.safeParse(value)
  return parsed.success ? (parsed.data as Brand) : Brand.default
}
